module.exports = __webpack_public_path__ + "img/empty-conversation.ee1347c3.svg";